export const invalidMetroUserArgumentsError =
  'all arguments to MetroUser constructor must be a valid string';
export const invalidClientIdError = 'optional `clientId` property in MetroUser must be a string';
export const invalidEmailError = 'optional `email` property in MetroUser must be a string';
export const invalidSubscriptionIdError =
  'optional `subscriptionId` property in MetroUser must be a string';
export const invalidAccountStatusError =
  'optional `accountStatus` property in MetroUser must be a string';
export const invalidIpAddressError = 'optional `ipAddress` property in MetroUser must be a string';

/**
 * @name MetroUser
 * @description The `MetroUser` class provides a helpful utility to
 * create valid `MetroUser` objects, for use with `MetroHelper`.
 */
export class MetroUser {
  /**
   * @param clientId - user's client id (optional)
   * @param email - user's email address (optional)
   * @param subscriptionId - user's subscription id (optional)
   * @param accountStatus - user's account status (e.g. 'active', 'closed') (optional)
   * @param ipAddress - user's ip address (optional)
   */
  constructor(
    public clientId = 'unknown',
    public email = 'unknown',
    public subscriptionId = 'unknown',
    public accountStatus = 'unknown',
    public ipAddress = 'unknown',
  ) {
    if (
      typeof clientId !== 'string' ||
      typeof email !== 'string' ||
      typeof subscriptionId !== 'string' ||
      typeof accountStatus !== 'string' ||
      typeof ipAddress !== 'string'
    ) {
      throw new Error(invalidMetroUserArgumentsError);
    }
  }

  /**
   * Validates an existing JS object.
   *
   * @param obj - What to validate
   * @throws
   * @returns `true` if the object is valid, otherwise throws a helpful error
   */
  static validate(obj: unknown): true {
    if (typeof obj !== 'object' || obj === null) {
      throw new Error('Invalid object');
    }

    if (obj instanceof MetroUser) {
      return true;
    }

    if ('clientId' in obj && typeof obj.clientId !== 'string') {
      throw new Error(invalidClientIdError);
    }

    if ('email' in obj && typeof obj.email !== 'string') {
      throw new Error(invalidEmailError);
    }

    if ('subscriptionId' in obj && typeof obj.subscriptionId !== 'string') {
      throw new Error(invalidSubscriptionIdError);
    }

    if ('accountStatus' in obj && typeof obj.accountStatus !== 'string') {
      throw new Error(invalidAccountStatusError);
    }

    if ('ipAddress' in obj && typeof obj.ipAddress !== 'string') {
      throw new Error(invalidIpAddressError);
    }

    return true;
  }
}
